import { useEffect, useState } from 'react';
import { Grid, makeStyles, Typography } from "@material-ui/core";
//import UtilService from "../../../../../../../helper/service";
//import clsx from 'clsx';
import { useDispatch, useSelector } from "react-redux";
import { getSegmentAsClip, } from '../../../../../../../store/actions/creator/analysis';
//import AnalysisScoreIcon from '../../../../../../atoms/creator/analyzeScoreIcon';
//import LinearProgress from '@material-ui/core/LinearProgress';
//import { Skeleton } from '@material-ui/lab';
//import GraphAreaSection from '../performance/graphArea';

interface IProps {
  session: any;
  participantsStatus: any;
  immersionData: any;
  thumbnail: any;
  safetyData: any;
  sessionCode: string;
  isMobile: boolean;
  confidenceScore: string;
}

const OverallPerformanceActions = (props: IProps) => {
  const classes = useStyles();
  const { participantsStatus, session, immersionData, safetyData, isMobile, confidenceScore } = props;
  const { sessionOverview, fullLoaded } = useSelector((state: any) => state.creatorExperienceManager);
  //const { stimulus, clipLoaded, identifiers, immersion_overall, safety_overall, cliped, settings, all, excludedParticipants } = useSelector((state: any) => state.analysis);
  const { stimulus, clipLoaded, settings} = useSelector((state: any) => state.analysis);
  const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
  const { pdfLoading } = settings;

  const dispatch = useDispatch();
  const [expLength, setExpLength] = useState<any>('Processing...');
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""

  if (pdfLoading === 'foo') {

  console.log(`session = ${JSON.stringify(session)}`);

  console.log(expLength);
  console.log(participantsStatus);
  console.log(immersionData);
  console.log(safetyData);
  console.log(isMobile);
  console.log(sessionOverview);
  console.log(fullLoaded);
  console.log(pdfLoading);
  }



  const getGeneralImpression = () => {
    if (session && immersionData && confidenceScore) {
      if (confidenceScore === 'A+' || confidenceScore === 'A') {
        if (immersionData.immersion_index >= 66) {
          return `Boom! You crushed this one!  With an Immersion score of ${immersionData.immersion_index} and an ${confidenceScore} Confidence level, you should get launch this content today.`;
        } else if (immersionData.immersion_index >= 36 && immersionData.immersion_index < 66) {
          return `Nice work!  With an Immersion score of ${immersionData.immersion_index} and an ${confidenceScore} Confidence level, you can expect that this content will perform well in market. You still have some things you can improve, however, as long as you are happy with the demographics of your audience in this test, you should launch.`;
        } else {
          return `Hmmm... It seems people didn't fall in love with this experience. With an Immersion score of ${immersionData.immersion_index}, we would recommend that you check if you are targeting the right audience or have a deeper look at this content. The good news is that you caught this early before spending your budget on distribution.`;
        }
      } else if (confidenceScore === 'B+' || confidenceScore === 'B') {
        if (immersionData.immersion_index >= 66) {
          return `Wow! An Immersion score of ${immersionData.immersion_index} is really great.  This is significantly higher than we usually see for similar content. Your next step should be to increase your confidence level in this result. Double check the demographic groups you targeted and measure a few more brains to increase your confidence level.`;
        } else if (immersionData.immersion_index >= 36 && immersionData.immersion_index < 66) {
          return `Looking good.  This content is pretty strong but still has some room to improve. If you are still in development-mode, then review the detailed second-by-second to look for opportunities. If you are ready to launch this, we would suggest you add a few more brains into the mix to increase your confidence level.`;
        } else {
          return `You are headed in the right direction. The content here didn't captivate many people, but you did a great job of building your confidence level.  We would suggest looking at your demographic groups and adding a few more brains to make sure you are targeting the right audience.`;
        }
      } else {
        if (immersionData.immersion_index >= 66) {
          return `Super cool!  It's always fun to get a huge Immersion score like ${immersionData.immersion_index}. Keep in mind your ${confidenceScore} Confidence level. You should use this result as guidance, but you will need to measure more brains to get confident in this content.`;
        } else if (immersionData.immersion_index >= 36 && immersionData.immersion_index < 66) {
          return `Alright, alright, alright! Based on your Immersion score of ${immersionData.immersion_index}, this is likely to be a very strong experience for people.  The trick now is to increase your Confidence level in the result.  Add a few more brains, and let's see how this will perform with your target audience.`;
        } else {
          return `Yikes. Here is the good news:  even though this scored a ${immersionData.immersion_index} you have such a low Confidence score right now that this could be a fluke or just the wrong audience for your content. Add some more brains before you start re-editing.`;
        }
      }
 
    }
  }


 



  //const isGraphImmersion = graphs.length > 0 && graphs[0]?.immersion?.data.length > 0;
  //const isSafety = UtilService.isShowSafety(session?.session_type, cliped ? cliped.end_clip - cliped.start_clip : session?.session_length);
  //const isGraphSaftey = graphs.length > 0 && graphs[0]?.safety?.length > 0 && (
  //  (currentSessionCode && stimulus && session?.session_type === 'ASYNC') ? session?.session_length > 120 : true);
  //const isGraphAvailable = (session?.session_type === 'ASYNC' || (session?.session_type === 'MODERATED' && session?.session_status === 'COMPLETED'))

  useEffect(() => {
    if (session?.session_length) {
      setExpLength(session?.session_length)
    }
  }, [session]);

  useEffect(() => {
    if (currentSessionCode && stimulus && session?.session_type === 'ASYNC') {
      dispatch(getSegmentAsClip(loginUserData.customer_id, stimulus.stimulus_id))
    }
    if (currentSessionCode && session?.session_type === 'MODERATED') {
      dispatch(getSegmentAsClip(loginUserData.customer_id, currentSessionCode))
    }
  }, [currentSessionCode, clipLoaded, stimulus?.stimulus_id, session]);

  
 



  return (
    <div className={classes.root}>
      

      <Grid container direction={'column'} alignContent={'center'} alignItems={'center'} style={{ padding: 15 }}>
      <Grid item xs={10} id={'actionsbox'} >
        <div style={{width: '100%'}}>
        <Typography variant="h5" className={classes.sectionTitle}>Actions:</Typography>
        <ul>
        <li>{session && getGeneralImpression()}</li>
        
        </ul>
        </div>
      </Grid>

      
      </Grid> 




      

      
    </div>
  )
};

export default OverallPerformanceActions;



const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 0,
    '@media (max-width: 600px)': {
      paddingTop: 0,
    },
  },
  sectionTitle: {
    fontSize: 24,
    fontFamily: 'Spartan-bold',
    color: '#697683'
  },
  typeTitle: {
    fontSize: 24,
    fontFamily: 'Spartan-bold',
    color: '#697683',
    textAlign: 'center',
  },
  titleSection: {
    maxWidth: 500,
    display: 'flex',
    alignItems: 'center'
  },
  numberTitle: {
    marginTop: 5,
    fontSize: 29,
    minWidth: 60,
    textAlign: 'center',
    fontFamily: 'Spartan-extrabold',
    padding: '0 15px',
    '@media screen and (max-width: 600px)': {
      fontSize: 30
    }
  },
  title: {
    minWidth: 146,
    marginTop: 5,
    fontSize: 20,
    fontFamily: 'Spartan-bold',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    '@media screen and (min-width: 331px) and (max-width: 600px)': {
      fontSize: 20
    },
    '@media screen and (max-width: 330px)': {
      fontSize: 18
    }
  },
  titleIcon: {
    width: 42,
    height: 42,
    '@media screen and (min-width: 331px) and (max-width: 600px)': {
      width: 35,
      height: 35
    },
    '@media screen and (max-width: 330px)': {
      width: 30,
      height: 30
    }
  },
  cardSection: {
    borderRadius: 20,
    background: '#fff',
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
  },
  pdfCardSection: {
    borderRadius: 20,
    background: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  foo:{},
  content: {
    display: 'flex',
    flexDirection: 'row',
    padding: '20px 20px 10px 20px',
    '@media screen and (max-width: 1150px)': {
      padding: '10px 0 5px 10px'
    },
    '@media screen and (max-width: 1023px)': {
      padding: '20px 20px 10px 20px',
    },
    '@media screen and (max-width: 600px)': {
      padding: '10px 10px 5px 10px'
    },
  },
  zenDescription: {
    minHeight: 25,
    fontSize: 14,
    fontFamily: 'roboto-medium',
    color: '#8192A2',
    lineHeight: '19px',
    marginTop: 40,
    '@media screen and (max-width: 600px)': {
      fontSize: 12
    }
  },
  section: {
    flex: 2
  },
  thumbdiv: {
    flex: 1,
    padding: '8px 20px',
    marginRight: 30,
    '@media screen and (max-width: 1150px)': {
      marginRight: 10,
    },
    '@media screen and (max-width: 600px)': {
      padding: 5,
      marginRight: 0,
      display: 'flex',
      alignItems: 'center'
    },
  },
  upDownArrow: {
    width: 13,
    height: 11
  },
  upDownLabel: {
    fontFamily: 'Spartan-extrabold',
    fontSize: 16,
    paddingLeft: 8,
    paddingRight: 8,
    marginTop: 3
  },
  normsAverageLabel: {
    fontFamily: 'roboto-bold',
    fontSize: 14,
    color: '#212D40'
  },
  scoreDiv: {
    marginTop: 20
  },
  diffDescription: {
    marginTop: 5
  },
  rowCol: {
    display: 'flex',
    flexDirection: 'column',
  },
  rowCenter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  categoryTitle: {
    fontSize: 16,
    fontFamily: 'roboto-regular',
    color: '#697683',
    marginTop: 30,
    lineHeight: 1.5,
    marginBottom: 30
  },
  bagIcon: {
    height: 12,
    position: 'absolute',
    top: 21
  },
  graphBar: {
    width: 1,
    height: 15,
    marginLeft: 6,
    background: '#111',
    position: 'absolute',
  }
}));